module.exports = __webpack_public_path__ + "static/32DCAF_0_0-fbda4b3f26e65f52ae5bae63704ac189.woff2";